import { supabase } from "../supabaseClient";

let pendingUserPromise = null;

export const getAdminUser = async () => {
  if (!pendingUserPromise) {
    pendingUserPromise = supabase.auth
      .getSession()
      .then(({ data, error }) => {
        if (error) {
          throw error;
        }
        return data?.session?.user || null;
      })
      .finally(() => {
        pendingUserPromise = null;
      });
  }

  return pendingUserPromise;
};